export const equipNews = [
  {
    id: 1,
    image: '/images/newsLogos/img1.svg',
    description:
      'Startup Equip va por nueva ronda de inversión para potenciar su ingreso a provincias.',
    link: 'https://gestion.pe/economia/empresas/startup-equip-va-por-nueva-ronda-de-inversion-para-potenciar-su-ingreso-a-provincias-sector-construccion-emprendimiento-materiales-de-construccion-tecnologia-noticia/',
  },
  {
    id: 2,
    image: '/images/newsLogos/img2.svg',
    description: 'Listado Forbes | Estas son las 100 mejores startups de Perú en 2024.',
    link: 'https://forbes.pe/editors-pick/2024-07-02/listado-forbes-estas-son-las-100-mejores-startups-de-peru-en-2024',
  },
  {
    id: 3,
    image: '/images/newsLogos/img3.svg',
    description:
      'Startup en la mira: Equip, la peruana que busca extender el alcance de su marketplace B2B de materiales de construcción.',
    link: 'https://semanaeconomica.com/sectores-empresas/tecnologia/startup-en-la-mira-equip-la-startup-peruana-que-opera-un-marketplace-de-construccion',
  },
  {
    id: 4,
    image: '/images/newsLogos/img4.svg',
    description: 'Un emprendimiento enfocado en materiales de construcción que escala.',
    link: 'https://www.ulima.edu.pe/alumni/noticias/un-emprendimiento-enfocado-en-materiales-de-construccion-que-escala',
  },
  {
    id: 5,
    image: '/images/newsLogos/img5.svg',
    description: 'Equip espera extender el alcance de su marketplace B2B.',
    link: 'https://www.ecommercenews.pe/comercio-electronico/2024/equip-espera-extender-el-alcance-de-su-marketplace-b2b.html/',
  },
  {
    id: 6,
    image: '/images/newsLogos/img6.svg',
    description: '¿Qué es una ConstrucTech y cómo estas startups están innovando en este sector?',
    link: ' https://www.youtube.com/watch?v=WbIGair2uOI',
  },
  {
    id: 7,
    image: '/images/newsLogos/img7.svg',
    description: 'Cuáles son las 100 mejores startups de Perú este 2024.',
    link: 'https://tyba.pe/blog/mejores-startups/',
  },
]
